var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocIconLigth(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 27,
    viewBox: "0 0 23 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0161 11.4631C15.0161 12.1158 14.8176 12.7538 14.4459 13.2965C14.0742 13.8392 13.5458 14.2621 12.9277 14.5119C12.3095 14.7617 11.6293 14.827 10.973 14.6997C10.3168 14.5723 9.71399 14.2581 9.24087 13.7965C8.76774 13.335 8.44554 12.747 8.31501 12.1069C8.18447 11.4667 8.25147 10.8032 8.50752 10.2002C8.76357 9.59723 9.19718 9.08185 9.75352 8.71924C10.3099 8.35663 10.9639 8.16309 11.633 8.16309C12.0773 8.16309 12.5172 8.24844 12.9277 8.41428C13.3381 8.58012 13.711 8.8232 14.0252 9.12963C14.3393 9.43607 14.5885 9.79986 14.7585 10.2002C14.9286 10.6006 15.0161 11.0297 15.0161 11.4631Z",
    stroke: "#727477",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 11.464C22 19.164 11.5 25.764 11.5 25.764C11.5 25.764 1 19.164 1 11.464C1 8.83832 2.10625 6.32022 4.07538 4.46361C6.04451 2.607 8.71523 1.56396 11.5 1.56396C14.2848 1.56396 16.9555 2.607 18.9246 4.46361C20.8938 6.32022 22 8.83832 22 11.464Z",
    stroke: "#727477",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocIconLigth);
export default __webpack_public_path__ + "static/media/locIconLigth.561831176ee7e589f747b520cab00c10.svg";
export { ForwardRef as ReactComponent };